var map = {
	"./AashiqueAhmedIqbal.png": 603,
	"./BusinessintheTimeofContagion.jpeg": 604,
	"./KarunaWielenga.png": 605,
	"./LakshmiSubramanian.png": 606,
	"./LouizaRodrigues.png": 607,
	"./MadMenofBombay.png": 608,
	"./MilanBalaban.png": 609,
	"./PowerPrivilegePosture.jpeg": 610,
	"./SaritaSundar.png": 611,
	"./Speaker1.png": 612,
	"./SusiePak.png": 613,
	"./TheGlobalBlueJeansTransformation.jpg": 614,
	"./TimberTradeTrajectory.jpeg": 615,
	"./TraceyPanek.png": 616,
	"./TypewriterTipTip.png": 617,
	"./WilliamMazzarella.png": 618,
	"./details-banner/BusinessInTheTimeOfContagion.png": 619,
	"./details-banner/MadMenOfBombay.png": 620,
	"./details-banner/PowerPrivilegeposture.png": 621,
	"./details-banner/TheGlobalBlueJeans.png": 622,
	"./details-banner/TimberTradeTrajectory.png": 623,
	"./details-banner/TypewriterTipTip.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 602;